import { render, staticRenderFns } from "./ExtractCausal.vue?vue&type=template&id=53374a37&"
import script from "./ExtractCausal.vue?vue&type=script&lang=ts&"
export * from "./ExtractCausal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports